import { ref, get } from "firebase/database";
import { useState, useEffect } from "react";
import { auth, db } from "../firebase"; // Your Firebase configuration

const useAdminStatus = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAdminStatus = async () => {
      const user = auth.currentUser;
      if (user) {
        const userId = user.uid;
        const userRef = ref(db, `users/${userId}`);

        try {
          const snapshot = await get(userRef);
          if (snapshot.exists() && snapshot.val().isAdmin) {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchAdminStatus();
  }, []);

  return { isAdmin, loading };
};

export default useAdminStatus;
